import { render } from "./OrangeButton.vue?vue&type=template&id=7f069a85&scoped=true"
import script from "./OrangeButton.vue?vue&type=script&lang=js"
export * from "./OrangeButton.vue?vue&type=script&lang=js"

import "./OrangeButton.vue?vue&type=style&index=0&id=7f069a85&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f069a85"]])

export default __exports__